import { call, put, takeLatest } from 'redux-saga/effects';
import { AdminCompetences } from 'services/api';
import {
  updateCompetenceGroup,
  updateCompetenceGroupSuccess,
  updateCompetenceGroupFailure,
  getAdminCompetences,
} from '../../actions';
import { actions as notificationActions } from 'components/Notification';
import { clearFilter } from 'components/CompetenceFilter/actions';

function* updateCompetenceGroupSaga({ payload }) {
  try {
    const data = yield call(
      AdminCompetences.updateCompetenceGroup,
      payload.values.id,
      { competenceGroup: payload.values }
    );
    yield put(updateCompetenceGroupSuccess(data));
    yield put(getAdminCompetences({ locale: payload.locale }));
    yield put(clearFilter());
    yield put(
      notificationActions.addNotification([
        { type: 'success', message: { code: 'saved', resource: 'changes' } },
      ])
    );
  } catch (e) {
    yield put(updateCompetenceGroupFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () =>
  takeLatest(updateCompetenceGroup, updateCompetenceGroupSaga);
